import { z } from "zod";
import { isoDateOnlySchema } from "../common/date.js";
import { lengthDiscountAppliedSchema } from "../property-length-discount/length-discount-applied.js";
export const publicPriceCalculationSchema = z.object({
    start_date: isoDateOnlySchema,
    end_date: isoDateOnlySchema,
    num_adults: z.number().int().min(1).optional(),
});
export const publicPriceCalculationLineSchema = z.object({
    date: isoDateOnlySchema,
    price: z.number().int().min(0),
});
export const publicPriceCalculationResultSchema = z.object({
    total_price: z.number().int().min(0),
    num_nights: z.number().int().min(0),
    breakdown: z.array(publicPriceCalculationLineSchema),
    subtotal_nights_cents: z.number().int().min(0),
    discount: lengthDiscountAppliedSchema.nullable(),
    tourist_tax_cents: z.number().int().min(0),
    tourist_tax_per_adult_cents: z.number().int().min(0),
    deposit_amount: z.number().int().min(0),
    remainder_amount: z.number().int().min(0),
    deposit_percentage: z.number().int().min(0).max(100),
    balance_due_days_before: z.number().int().min(0).max(365),
    remainder_due_at: z.string().nullable(),
});
export const publicPriceCalculationResponseSchema = z.object({
    price: publicPriceCalculationResultSchema,
});
